<div *ngIf="gridData">
  <div *ngIf="ratioId && orientation === 'list'">
    <div
      style="
        background-color: #f2f4f7;
        height: 26px;
        color: black;
        font-weight: bold;
        border-top: 1px solid rgb(197, 204, 214);
        border-right: 1px solid rgb(197, 204, 214);
        border-left: 1px solid rgb(197, 204, 214);
        padding: 5px;
        font-size: 12px;
      "
    >
      {{ gridData.colInfo[ratioId]["label"] }}
    </div>
  </div>
  <div class="valuation-grid-container" [ngClass]="containerClassName">
    <table
      mat-table
      [dataSource]="matDataSource"
      *ngIf="matDataSource && matDataSource.data.length"
      cellpadding="0"
      cellspacing="0"
    >
      <!-- Ticker Column -->
      <ng-container matColumnDef="C0" sticky>
        <th mat-header-cell *matHeaderCellDef class="fixed-col cell-font">
          <div class="ticker-column">
            Ticker ({{ matDataSource.data.length }})
          </div>
        </th>
        <td class="ticker-cell fixed-col" mat-cell *matCellDef="let element">
          <div class="display-flex flex-justify-between cell-font">
            <span style="padding-right: 4px; padding-left: 8px">
              <a
                class="no-decor"
                routerLink="{{ '/company/' + element.ticker }}"
                routerLinkActive
              >
                {{ element.C0 }}
              </a>
            </span>
          </div>
        </td>
        <td
          mat-footer-cell
          *matFooterCellDef
          class="cell-right-border summary-title-cell"
        >
          <div
            *ngIf="showAverage"
            class="data-summary-cell footer-cell"
            style="padding-left: 8px; padding-top: 4px"
          >
            Average
          </div>
          <div
            *ngIf="showMedian"
            class="data-summary-cell footer-cell"
            style="padding: 5px; padding-left: 8px"
          >
            Median
          </div>
        </td>
      </ng-container>

      <!-- Company name Column -->
      <ng-container matColumnDef="C1">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('C1')"
          class="fixed-col"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="company-name-column">
            <span> Company Name </span>
            <span *ngIf="!isDataInProgress" class="sort-section">
              <div>
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'C1' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 8px">
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortDown"
                  [ngStyle]="{
                    color:
                      activeSort === 'C1' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [title]="element.C1"
          class="fixed-col"
        >
          <div class="company-name-column cell-font" style="padding-left: 5px">
            {{ element.C1 }}
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="cell-right-border"></td>
      </ng-container>

      <!-- Market cap Column -->
      <ng-container matColumnDef="C2">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('C2')"
          class="fixed-col"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="market-cap-column">
            <span style="display: inline-block; width: 58px"> Market cap </span>
            <span
              [ngClass]="{ 'hide-sort-button': isDataInProgress }"
              class="sort-section"
            >
              <div>
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'C2' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 8px">
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortDown"
                  [ngStyle]="{
                    color:
                      activeSort === 'C2' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            *ngIf="element.C2.isLoading"
            class="ratio-cell table-cell-width"
            style="padding-left: 5px; padding-right: 5px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
          <div
            *ngIf="!element.C2.isLoading"
            class="ratio-cell table-cell-width"
            [ngClass]="{
              'negative-value': element.C2.raw < 0,
              'selected-cell': selectedCell === element.ticker + '_C2_'
            }"
            (click)="
              onCellClick(
                $event,
                element['C2']['rd'],
                'C2',
                element['C2']['periodValue'],
                element.ticker,
                element.ticker,
                element['C2']['isForecast'],
                element['C2']['viewBy'],
                {
                  value: element['C2']['formatted'],
                  colInfo: gridData.colInfo['C2']
                }
              )
            "
          >
            <ng-container *ngIf="element.C2.formatted !== '-'; else emptyData">
              <span nz-tooltip [nzTooltipTitle]="mkapTooltip">
                {{ element.C2.formatted }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span>
                {{ element.C2.formatted }}
              </span>
            </ng-template>
          </div>
          <ng-template #mkapTooltip>
            <div class="ca-tooltip-content">
              {{ element.C2.formatted }}
              <br />
              {{ element.C2.lastDate }}
              <br />
              {{ element.C2.exchangeFullName }}
            </div>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <ng-container *ngIf="showAverage">
            <div
              *ngIf="!gridData.footerData.average.C2"
              class="ratio-cell table-cell-width"
              style="padding-left: 5px; padding-right: 5px"
            >
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </div>
            <div
              *ngIf="gridData.footerData.average.C2"
              class="ratio-cell table-cell-width"
              [ngClass]="{
                'negative-value': gridData.footerData.average.C2['raw'] < 0
              }"
              [title]="gridData.footerData.average.C2.formatted"
            >
              {{ gridData.footerData.average.C2["formatted"] }}
            </div>
          </ng-container>
          <ng-container *ngIf="showMedian">
            <div
              *ngIf="!gridData.footerData.median.C2"
              class="ratio-cell table-cell-width"
              style="
                padding-left: 5px;
                padding-right: 5px;
                display: inline-block;
              "
            >
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </div>
            <div
              *ngIf="gridData.footerData.median.C2"
              class="ratio-cell table-cell-width"
              style="display: inline-block"
              [ngClass]="{
                'negative-value': gridData.footerData.median.C2['raw'] < 0
              }"
              [title]="gridData.footerData.median.C2.formatted"
            >
              {{ gridData.footerData.median.C2["formatted"] }}
            </div>
          </ng-container>
        </td>
      </ng-container>

      <!-- EV Column -->
      <ng-container matColumnDef="C3">
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="sortData('C3')"
          class="fixed-col"
          [ngClass]="[
            isDataInProgress ? 'disable-header-sort' : 'enable-header-sort'
          ]"
        >
          <div class="ev-column">
            <span style="display: inline-block; width: 58px">
              Enterprise Value
            </span>
            <span
              [ngClass]="{ 'hide-sort-button': isDataInProgress }"
              class="sort-section"
            >
              <div>
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortUp"
                  [ngStyle]="{
                    color:
                      activeSort === 'C3' && sortDirection === 'asc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
              <div style="position: absolute; top: 8px">
                <va-icon
                  size="small"
                  isFontAwesome="true"
                  [name]="faSortDown"
                  [ngStyle]="{
                    color:
                      activeSort === 'C3' && sortDirection === 'desc'
                        ? '#36abad'
                        : 'lightgray'
                  }"
                >
                </va-icon>
              </div>
            </span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            *ngIf="element.C3.isLoading"
            class="ratio-cell table-cell-width"
            style="padding-left: 5px; padding-right: 5px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
          <div
            *ngIf="!element.C3.isLoading"
            class="ratio-cell table-cell-width"
            [ngClass]="{
              'negative-value': element.C3.raw < 0,
              'selected-cell': selectedCell === element.ticker + '_C3_'
            }"
            (click)="
              onCellClick(
                $event,
                element['C3']['rd'],
                'C3',
                element['C3']['periodValue'],
                element.ticker,
                element.ticker,
                element['C3']['isForecast'],
                element['C3']['viewBy'],
                {
                  value: element['C3']['formatted'],
                  colInfo: gridData.colInfo['C3']
                }
              )
            "
          >
            <ng-container *ngIf="element.C3.formatted !== '-'; else emptyData">
              <span nz-tooltip [nzTooltipTitle]="evTooltip">
                {{ element.C3.formatted }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span>
                {{ element.C3.formatted }}
              </span>
            </ng-template>
          </div>
          <ng-template #evTooltip>
            <div class="ca-tooltip-content">
              {{ element.C3.formatted }}
              <br />
              {{ element.C3.lastDate }}
              <br />
              {{ element.C3.exchangeFullName }}
            </div>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <ng-container *ngIf="showAverage">
            <div
              *ngIf="!gridData.footerData.average.C3"
              class="ratio-cell table-cell-width"
              style="padding-left: 5px; padding-right: 5px"
            >
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </div>
            <div
              *ngIf="gridData.footerData.average.C3"
              class="ratio-cell table-cell-width"
              [ngClass]="{
                'negative-value': gridData.footerData.average.C3['raw'] < 0
              }"
              [title]="gridData.footerData.average.C3.formatted"
            >
              {{ gridData.footerData.average.C3["formatted"] }}
            </div>
          </ng-container>
          <ng-container *ngIf="showMedian">
            <div
              *ngIf="!gridData.footerData.median.C3"
              class="ratio-cell table-cell-width"
              style="
                padding-left: 5px;
                padding-right: 5px;
                display: inline-block;
              "
            >
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </div>
            <div
              *ngIf="gridData.footerData.median.C3"
              class="ratio-cell table-cell-width"
              style="display: inline-block"
              [ngClass]="{
                'negative-value': gridData.footerData.median.C3['raw'] < 0
              }"
              [title]="gridData.footerData.median.C3.formatted"
            >
              {{ gridData.footerData.median.C3["formatted"] }}
            </div>
          </ng-container>
        </td>
      </ng-container>

      <!-- Last Price Column -->
      <ng-template
        #lastPrice
        let-col="col"
        let-element="element"
        let-subCol="subCol"
      >
        <div style="display: flex; height: 26px">
          <div
            class="ratio-cell"
            style="display: inline-block"
            nz-tooltip
            [ngClass]="{
              'negative-value':
                element[col]['subColumns'][subCol.id]['raw'] < 0,
              'selected-cell':
                selectedCell === element.ticker + '_' + col + '_' + subCol.id,
              'gaap-cell':
                element[col]['subColumns'][subCol.id]['primarySli'] ===
                  'GAAP' && highlightGAAP
            }"
            (click)="
              onCellClick(
                $event,
                element[col]['subColumns'][subCol.id]['rd'],
                col,
                element[col]['subColumns'][subCol.id]['periodValue'],
                element.ticker,
                element.ticker,
                element[col]['subColumns'][subCol.id]['isForecast'],
                element[col]['subColumns'][subCol.id]['viewBy'],
                {
                  value: element[col]['subColumns'][subCol.id].formatted,
                  colInfo: gridData.colInfo[col]
                },
                subCol.id
              )
            "
          >
            <ng-container
              *ngIf="
                element[col]['subColumns'][subCol.id]['formatted'] !== '-' &&
                  element[col]['subColumns'][subCol.id].apiType === 'price';
                else emptyData
              "
            >
              <span nz-tooltip [nzTooltipTitle]="mkapTooltip">
                {{ element[col]["subColumns"][subCol.id]["formatted"] }}
              </span>
            </ng-container>
            <ng-template #emptyData>
              <span [title]="element[col]['subColumns'][subCol.id].formatted">
                {{ element[col]["subColumns"][subCol.id]["formatted"] }}
              </span>
            </ng-template>
            <ng-template #mkapTooltip>
              <div class="ca-tooltip-content">
                {{ element[col]["subColumns"][subCol.id]["formatted"] }}
                <br />
                {{ element[col]["subColumns"][subCol.id]["lastDate"] }}
                <br />
                {{ element[col]["subColumns"][subCol.id]["exchangeFullName"] }}
              </div>
            </ng-template>
          </div>
        </div>
      </ng-template>

      <ng-template
        #ratingDistribution
        let-col="col"
        let-element="element"
        let-subCol="subCol"
      >
        <ng-template #ratingPopover>
          <div>
            <div class="rating-detail">
              <div class="broker-numbers rating-dist-table">
                <div class="header">#</div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["buy"]["abs"] }}
                </div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["hold"]["abs"] }}
                </div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["sell"]["abs"] }}
                </div>
              </div>
              <div class="broker-percent rating-dist-table">
                <div class="header">%</div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["buy"]["perc"] }}
                </div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["hold"]["perc"] }}
                </div>
                <div class="rating-cell">
                  {{ element[col]["subColumns"][subCol.id]["sell"]["perc"] }}
                </div>
              </div>
              <div class="broker-label rating-dist-table">
                <div class="header">Rating</div>
                <div class="rating-cell">
                  <div class="rating-label green">BUY</div>
                </div>
                <div class="rating-cell">
                  <div class="rating-label yellow">HOLD</div>
                </div>
                <div class="rating-cell">
                  <div class="rating-label red">SELL</div>
                </div>
              </div>
            </div>
            <div class="footer">
              Total # of Brokers:
              {{ element[col]["subColumns"][subCol.id]["total"] }}
            </div>
          </div>
        </ng-template>
        <!-- Distribution sub column -->
        <div class="distribution-bar">
          <div
            *ngIf="
              !element[col]['subColumns'][subCol.id]?.['sell'] ||
              !element[col]['subColumns'][subCol.id]?.['hold'] ||
              !element[col]['subColumns'][subCol.id]?.['buy'] ||
              (element[col]['subColumns'][subCol.id]['sell']['abs'] === 0 &&
                element[col]['subColumns'][subCol.id]['hold']['abs'] === 0 &&
                element[col]['subColumns'][subCol.id]['buy']['abs'] === 0)
            "
          >
            -
          </div>
          <div
            class="bar-container"
            nz-popover
            nzPopoverOverlayClassName="rating-distribution-popover"
            [nzPopoverContent]="ratingPopover"
            *ngIf="
              (element[col]['subColumns'][subCol.id]?.['sell'] &&
                element[col]['subColumns'][subCol.id]['sell']['abs'] !== 0) ||
              (element[col]['subColumns'][subCol.id]?.['hold'] &&
                element[col]['subColumns'][subCol.id]['hold']['abs'] !== 0) ||
              (element[col]['subColumns'][subCol.id]['buy'] &&
                element[col]['subColumns'][subCol.id]['buy']['abs'] !== 0)
            "
          >
            <div
              class="sell-rating"
              *ngIf="element[col]['subColumns'][subCol.id]['sell']['abs'] !== 0"
              [style.width]="
                element[col]['subColumns'][subCol.id]['sell']['perc']
              "
            ></div>
            <div
              class="hold-rating"
              *ngIf="element[col]['subColumns'][subCol.id]['hold']['abs'] !== 0"
              [style.width]="
                element[col]['subColumns'][subCol.id]['hold']['perc']
              "
            ></div>
            <div
              class="buy-rating"
              *ngIf="element[col]['subColumns'][subCol.id]['buy']['abs'] !== 0"
              [style.width]="
                element[col]['subColumns'][subCol.id]['buy']['perc']
              "
            ></div>
          </div>
        </div>
      </ng-template>
      <ng-template
        #consensus
        let-element="element"
        let-subCol="subCol"
        let-col="col"
      >
        <!-- Consensus column  -->
        <div
          *ngIf="subCol.id === 'consensus_values'"
          style="display: flex; align-self: center"
          class="rating-column"
        >
          <!-- ['bgColor'] -->
          <span
            class="rating-label {{
              element[col]['subColumns'][subCol.id]['bgColor']
            }}"
          >
            <!-- ["label"] -->
            {{ element[col]["subColumns"][subCol.id]["label"] }}
          </span>
          <span class="sub-col-heading">
            <!-- ["value"] -->
            {{ element[col]["subColumns"][subCol.id]["value"] }}
          </span>
        </div>
      </ng-template>

      <ng-container *ngIf="orientation === 'grid'">
        <ng-container *ngFor="let col of columns">
          <ng-container *ngIf="specialColumns.indexOf(col) === -1">
            <ng-container [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef>
                <div
                  class="ratio-column-header"
                  [title]="gridData.colInfo[col]['label']"
                  [ngStyle]="{
                    'width.px':
                      gridData.colInfo[col].subheaders_info.length * 100
                  }"
                >
                  {{ gridData.colInfo[col]["label"] }}
                </div>
                <div
                  class="ratio-column-subheader"
                  *ngIf="
                    gridData.colInfo[col].subheaders_info &&
                    gridData.colInfo[col].subheaders_info.length
                  "
                >
                  <div
                    *ngFor="let subCol of gridData.colInfo[col].subheaders_info"
                    class="ratio-period table-cell-width table-cell-sub-column-cell"
                    (click)="
                      subCol.id !== RATING_DISTRIBUTION_COL_ID
                        ? sortData(col, subCol.id)
                        : undefined
                    "
                    [ngClass]="[
                      isDataInProgress
                        ? 'disable-header-sort'
                        : 'enable-header-sort',
                      subCol.id === RATING_DISTRIBUTION_COL_ID
                        ? 'rating-dist-header'
                        : subCol.id === 'consensus_values'
                          ? 'consensus-header'
                          : ''
                    ]"
                  >
                    <span class="sub-col-label">{{ subCol.label }}</span>
                    <span
                      [ngClass]="{ 'hide-sort-button': isDataInProgress }"
                      class="sort-section"
                      *ngIf="subCol.id !== RATING_DISTRIBUTION_COL_ID"
                    >
                      <div>
                        <va-icon
                          size="small"
                          isFontAwesome="true"
                          [name]="faSortUp"
                          [ngStyle]="{
                            color:
                              activeSort === col + '-' + subCol.id &&
                              sortDirection === 'asc'
                                ? '#36abad'
                                : 'lightgray'
                          }"
                        >
                        </va-icon>
                      </div>
                      <div style="position: absolute; top: 53px">
                        <va-icon
                          size="small"
                          isFontAwesome="true"
                          [name]="faSortDown"
                          [ngStyle]="{
                            color:
                              activeSort === col + '-' + subCol.id &&
                              sortDirection === 'desc'
                                ? '#36abad'
                                : 'lightgray'
                          }"
                        >
                        </va-icon>
                      </div>
                    </span>
                  </div>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">
                <div
                  class="display-flex"
                  *ngIf="
                    gridData.colInfo[col].subheaders_info &&
                    gridData.colInfo[col].subheaders_info.length
                  "
                >
                  <ng-container
                    *ngFor="let subCol of gridData.colInfo[col].subheaders_info"
                  >
                    <div
                      *ngIf="
                        element[col]['subColumns'] &&
                        element[col]['subColumns'][subCol.id] &&
                        element[col]['subColumns'][subCol.id]['isLoading']
                      "
                      class="ratio-cell table-cell-width"
                      style="
                        padding-left: 5px;
                        padding-right: 5px;
                        display: inline-block;
                      "
                    >
                      <nz-skeleton
                        [nzTitle]="true"
                        [nzActive]="true"
                        [nzParagraph]="false"
                      ></nz-skeleton>
                    </div>
                    <div
                      *ngIf="
                        element[col]['subColumns'] &&
                        element[col]['subColumns'][subCol.id] &&
                        !element[col]['subColumns'][subCol.id]['isLoading']
                      "
                      class="table-cell-sub-column-cell table-cell-width"
                    >
                      <div
                        *ngIf="
                          subCol.id !== 'consensus_values' &&
                          subCol.id !== RATING_DISTRIBUTION_COL_ID &&
                          subCol.id !== LAST_PRICE_COL_ID
                        "
                        style="display: flex; height: 26px"
                      >
                        <div
                          class="ratio-cell"
                          style="display: inline-block"
                          [ngClass]="{
                            'negative-value':
                              element[col]['subColumns'][subCol.id]['raw'] < 0,
                            'selected-cell':
                              selectedCell ===
                              element.ticker + '_' + col + '_' + subCol.id,
                            'gaap-cell':
                              element[col]['subColumns'][subCol.id][
                                'primarySli'
                              ] === 'GAAP' && highlightGAAP
                          }"
                          [title]="
                            element[col]['subColumns'][subCol.id].formatted
                          "
                          (click)="
                            onCellClick(
                              $event,
                              element[col]['subColumns'][subCol.id]['rd'],
                              col,
                              element[col]['subColumns'][subCol.id][
                                'periodValue'
                              ],
                              element.ticker,
                              element.ticker,
                              element[col]['subColumns'][subCol.id][
                                'isForecast'
                              ],
                              element[col]['subColumns'][subCol.id]['viewBy'],
                              {
                                value:
                                  element[col]['subColumns'][subCol.id]
                                    .formatted,
                                colInfo: gridData.colInfo[col]
                              },
                              subCol.id
                            )
                          "
                        >
                          {{
                            element[col]["subColumns"][subCol.id]["formatted"]
                          }}
                        </div>
                      </div>
                      <ng-container
                        *ngIf="subCol.id === LAST_PRICE_COL_ID"
                        [ngTemplateOutlet]="lastPrice"
                        [ngTemplateOutletContext]="{
                          subCol: subCol,
                          element: element,
                          col: col
                        }"
                      >
                      </ng-container>
                      <ng-container
                        *ngIf="subCol.id === 'consensus_values'"
                        [ngTemplateOutlet]="consensus"
                        [ngTemplateOutletContext]="{
                          subCol: subCol,
                          element: element,
                          col: col
                        }"
                      ></ng-container>
                      <ng-container
                        *ngIf="subCol.id == RATING_DISTRIBUTION_COL_ID"
                        [ngTemplateOutlet]="ratingDistribution"
                        [ngTemplateOutletContext]="{
                          subCol: subCol,
                          element: element,
                          col: col
                        }"
                      ></ng-container>
                    </div>
                  </ng-container>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef="let footer">
                <div class="data-summary-cell display-flex" *ngIf="showAverage">
                  <ng-container
                    *ngFor="let subCol of gridData.colInfo[col].subheaders_info"
                  >
                    <div
                      *ngIf="
                        !gridData.footerData.average[col] ||
                        (gridData.footerData.average[col] &&
                          !gridData.footerData.average[col][subCol.id])
                      "
                      class="ratio-cell table-cell-sub-column-cell"
                      style="padding-left: 5px; padding-right: 5px"
                    >
                      <nz-skeleton
                        [nzTitle]="true"
                        [nzActive]="
                          !(
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.id
                            ) ||
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.api_type
                            )
                          )
                        "
                        [nzParagraph]="false"
                        [nzLoading]="
                          !(
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.id
                            ) ||
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.api_type
                            )
                          )
                        "
                      ></nz-skeleton>
                    </div>
                    <div
                      *ngIf="
                        gridData.footerData.average[col] &&
                        gridData.footerData.average[col][subCol.id]
                      "
                      class="ratio-cell table-cell-sub-column-cell"
                      [ngClass]="{
                        'negative-value':
                          gridData.footerData.average[col][subCol.id]['raw'] < 0
                      }"
                      [title]="
                        gridData.footerData.average[col][subCol.id].formatted
                      "
                    >
                      {{
                        gridData.footerData.average[col][subCol.id]["formatted"]
                      }}
                    </div>
                  </ng-container>
                </div>
                <div class="data-summary-cell display-flex" *ngIf="showMedian">
                  <ng-container
                    *ngFor="let subCol of gridData.colInfo[col].subheaders_info"
                  >
                    <div
                      *ngIf="
                        !gridData.footerData.median[col] ||
                        (gridData.footerData.median[col] &&
                          !gridData.footerData.median[col][subCol.id])
                      "
                      class="ratio-cell table-cell-sub-column-cell"
                      style="
                        padding-left: 5px;
                        padding-right: 5px;
                        display: inline-block;
                      "
                    >
                      <nz-skeleton
                        [nzTitle]="true"
                        [nzActive]="
                          !(
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.id
                            ) ||
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.api_type
                            )
                          )
                        "
                        [nzParagraph]="false"
                        [nzLoading]="
                          !(
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.id
                            ) ||
                            gridData.footerData.subColumnsWithoutLoader.includes(
                              subCol.api_type
                            )
                          )
                        "
                      ></nz-skeleton>
                    </div>
                    <div
                      *ngIf="
                        gridData.footerData.median[col] &&
                        gridData.footerData.median[col][subCol.id]
                      "
                      class="ratio-cell table-cell-sub-column-cell"
                      style="display: inline-block"
                      [ngClass]="{
                        'negative-value':
                          gridData.footerData.median[col][subCol.id]['raw'] < 0
                      }"
                      [title]="
                        gridData.footerData.median[col][subCol.id].formatted
                      "
                    >
                      {{
                        gridData.footerData.median[col][subCol.id]["formatted"]
                      }}
                    </div>
                  </ng-container>
                </div>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <ng-container *ngIf="tabType !== 'company'">
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ 'selected-row': selectedRow == row.ticker }"
          (click)="onRowClick(row.ticker)"
        ></tr>
      </ng-container>

      <ng-container *ngIf="tabType !== 'company'">
        <tr
          mat-footer-row
          *matFooterRowDef="displayedColumns; sticky: true"
          class="footer-row"
        ></tr>
      </ng-container>
    </table>
  </div>
</div>
<mat-paginator
  [pageSize]="20"
  showFirstLastButtons
  [hidePageSize]="true"
  [length]="matDataSource.data.length"
  [disabled]="isDataInProgress"
  [ngClass]="{ 'hide-paginator': !gridData }"
>
</mat-paginator>
<div *ngIf="!gridData">
  <div class="valuation-grid-container">
    <ul nz-menu>
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</div>
